import { render, staticRenderFns } from "./MedicalAccordion.vue?vue&type=template&id=26eb06ce&scoped=true&"
import script from "./MedicalAccordion.vue?vue&type=script&lang=js&"
export * from "./MedicalAccordion.vue?vue&type=script&lang=js&"
import style0 from "./MedicalAccordion.vue?vue&type=style&index=0&id=26eb06ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eb06ce",
  null
  
)

export default component.exports